<template>
    <div class="container-fluid">

        <div class="row">
            <div class="col-md-12">
                <router-link tag="button" :to="{name: 'models.create'}" class="btn btn-info">
                    <span class="btn-label">
                        <i class="material-icons">add</i>
                    </span>
                    Novo
                </router-link>
            </div>
        </div>

         <FiltersModels @filterName='filterName' 
                        @resetFilters='resetFilters' 
                        @filterMarca='filterMarca' />
        
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header card-header-icon card-header-rose">
                        <div class="card-icon">
                            <i class="material-icons">list</i>
                        </div>
                        <h4 class="card-title ">Lista</h4>
                    </div>
                    <div class="card-body">
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th class="text-center">#</th>
                                        <th>Nome</th>
                                        <th>Marca</th>
                                        <th>Código</th>
                                        <th class="text-right">Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr 
                                        v-show="items.length > 0"
                                        v-for="iterator in items" 
                                        :key="iterator.id">
                                        <td class="text-center">{{ iterator.id }}</td>
                                        <td v-html="formatTextSearch(iterator.name)"></td>
                                        <td v-html="formatTextSearch(iterator.manufacturer.name)"></td>
                                        <td v-html="formatTextSearch(iterator.code)"></td>
                                        <td class="td-actions text-right">
                                <index-buttons
                                    :iterator=iterator
                                    :showAudit="false"
                                    :toAudit="{name: 'dashboard'}"
                                    :showEdit="true"
                                    :toEdit="{name: 'models.edit', params: { id: iterator.id }}"
                                    :showRemove="true"
                                    dispatchRemove="models/rem"
                                    :callbackRemove="getData"
                                    >
                            </index-buttons>
                            </td>
                            </tr>
                            <tr v-show="items.length==0">
                                <td colspan="5">Nenhum modelo encontrado!</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
    import FiltersModels from './FiltersModels';

    export default {
        components : { FiltersModels },
        computed: {
            items_: {
                set(_models) {
                },
                get(){ return this.$store.state.models.itens; }
            }
        },
        created() {
            this.getData();
            setTimeout(() => { this.items = this.items_; }, 500)
        },
        data() {
            return {
                currentPage: 1,
                items : [],
                textSearch : ''
            };
        },
        methods: {
            formatTextSearch(name){
                let re = new RegExp( '('+this.textSearch+')', 'ig' );
                return name.replace(re, '<b><u>$1</u></b>')
            },
            remove: function (_item) {
                var self = this;
                this.$dialog.confirm('Deseja realmente remover o modelo "' + _item.name + '"?')
                        .then(function () {
                            self.$root.$emit('onLoading');

                            const response = self.$store.dispatch('models/rem', _item);

                            response.then(function () {
                                self.$root.$emit('onLoading');
                                self.$notify.success("Modelo excluído com sucesso!");
                                self.getData();
                            });

                            response.catch(function () {
                                self.$root.$emit('onLoading');
                                self.$notify.danger("Não foi possível excluir o modelo!");
                            });
                        });
            },
            async getData() 
            {
                var self = this;

                self.$root.$emit('onLoading');
                const response = self.$store.dispatch('models/all');

                response.then(function () {
                    self.$root.$emit('onLoading');
                });

                response.catch(function () {
                    self.$root.$emit('onLoading');
                });
            },
            filterName( name ){ 
                this.textSearch = name;
                let re = new RegExp( name, 'gi');
                this.items = this.items_.filter( item => re.test( item.name) || re.test( item.manufacturer.name ) || re.test( item.code ));
            },
            filterMarca( id ){
                this.items = this.items_.filter(item => item.manufacturer.id == id)
            },
            resetFilters(){
                this.textSearch = '';
                this.items = this.items_;
            },
        }
    }
</script>